import { render } from "./MainMenuDropdownItem.vue?vue&type=template&id=2851634f"
import script from "./MainMenuDropdownItem.vue?vue&type=script&lang=js"
export * from "./MainMenuDropdownItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/mwon.net/gugar.mwon.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__